import Vue from "vue";
import _ from "lodash";

export function app(name, component) {
  const node = document.querySelector(`#vue-app[data-vue-app="${name}"]`);
  if (!node) return;

  Vue.config.productionTip = false;

  const props = {};
  _.entries(node.dataset).forEach(([key, value]) => {
    try {
      props[key] = JSON.parse(value);
    } catch (e) {
      props[key] = value;
    }
  });

  const instance = {
    name: "App",
    render(h) {
      return h(
        "div",
        {
          attrs: {
            id: `app-${name}`,
          },
        },
        [h(component, { props })]
      );
    },
  };

  return new Vue(instance).$mount(node);
}
